class WorkoutTypeInstance {
  constructor({ _id = '', title = '', workoutTypeModel = '', ...rest }) {
    this.id = _id;
    this.title = title;
    this.workoutTypeModel = workoutTypeModel;
    Object.assign(this, rest);
  }
}

export default WorkoutTypeInstance;
